import React from 'react';
import Segment, { SegmentProps } from './Segment';

type DefaultSegmentProps = Pick<
  SegmentProps,
  'isSelected' | 'onSelect' | 'recipientCount' | 'loadingCount' | 'disabled'
>;

const DefaultSegment = ({
  recipientCount,
  isSelected,
  onSelect,
  loadingCount,
  disabled,
}: DefaultSegmentProps): JSX.Element => {
  return (
    <Segment
      title="Active Clients"
      recipientCount={recipientCount}
      displayCount
      description="Active clients have had an appointment in the last 18 months, or have an appointment scheduled in the future."
      isSelected={isSelected}
      onSelect={onSelect}
      loadingCount={loadingCount}
      disabled={disabled}
    />
  );
};

export default DefaultSegment;
